import React, { useEffect } from "react";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  section: any;
}

const AmbassadorRoleDrawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  section,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  return (
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-30 transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      onClick={onClose}
    >
      <div
        className={`fixed top-0 right-0 h-full w-4/5 sm:w-1/2 md:w-1/3 lg:w-[465px] overflow-y-auto bg-white p-4 md:p-10 shadow-lg transition-transform duration-300 ease-in-out transform ${isOpen ? "translate-x-0" : "translate-x-full"
          }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black"
        >
          &times;
        </button>
        {section && (
          <div>
            <h2 className="text-2xl text-blackie font-semibold my-3">
              {section.heading}
            </h2>
            <div
              className="text-labelTextColor html-content"
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          </div>
        )}

      </div>
    </div>
  );
};

export default AmbassadorRoleDrawer;
